module.exports = __webpack_public_path__ + "img/mobilen-bipper-3.a4e14842.png";